import React from "react";
import moment from "moment";

const GlobalContext = React.createContext({
  events: [],
  eventsExtremeDates: {},
  selectedDay: 1,
  selectedMonth: moment().month(),
  selectedYear: moment().year(),
  setSelectedDay: () => {},
  setSelectedMonth: () => {},
  setSelectedYear: () => {},
  dateFormat: 'YYYY-MM-DD',
  DAYS_TRANSLATIONS: [],
  MONTHS_TRANSLATIONS: []
});

export default GlobalContext;
